import { gql } from '@apollo/client';

export default gql`
  query getHistory($bookingReference: String!, $page: Int, $size: Int) {
    history(bookingReference: $bookingReference, page: $page, size: $size) {
      totalCount
      details {
        revisionNumber
        actionType
        username
        office
        date
        actions
        revisionContents {
          first_confirmation
          customer_updated
          items_cancelled
          items_created
          items_updated
          passengers_created
          passengers_updated
          payments_created
          payments_updated
          validations_created
          validations_cancelled
        }
        data {
          customer {
            companyName
            firstName
            lastName
            email
            phoneNumber
          }
          passengers {
            uuid
            isCompany
            firstName
            lastName
            type
            disabilityType
          }
          payments {
            uuid
            reference
            amount
            currency
            method
            isPayout
            isDiscountCode
            discountAmount
            overrideReason {
              key
              value
            }
          }
          tickets {
            uuid
            ticketNo
            location
            validationType
          }
          bookingItemsActions {
            action
            segments {
              ...segment
            }
          }
          segmentIds {
            action
            uuids
          }
          content
        }
      }
    }
  }

  fragment product on HistoryDetailProduct {
    uuid
    loyaltyPoints
    isLoyalty
    passengerId
    passenger
    tariffName
    tariffCode
    price
    currency
    ticket
    seat
    eurostarReference
    jacTravelRef
    confirmedTimestamp
    hotelId
    hotelName
    numberOfNights
    guestCount
    roomCount
    hotelAddress
    insuranceDescription
    insurancePolicyNumber
    insuranceProviderSystem
    overrideReason {
      key
      value
    }
  }

  fragment segment on HistoryDetailBookingItemsSegment {
    uuid
    segmentName
    departureDate
    train
    departureTimeStation
    arrivalTimeStation
    requiredProducts {
      ...product
    }
    additionalProducts {
      ...product
    }
    fees {
      ...product
    }
  }
`;
